import React, { PropTypes } from 'react';
import { Divider, Checkbox } from 'material-ui';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import EditButton from '../../edit-button';
import Cell from '../../click-edit-cell';
import Miscellaneous from '../rates-table-miscellaneous.jsx';

const WithoutRetailRate = props => {
  const {
    rates,
    onEdit,
    deleteFromProduct,
    supplierEditable,
    withEditableCell,
    updateTableCell,
    forOffer,
    rateSetName,
    rateSetCode,
    classes = {},
    ...forMiscellaneous,
    } = props;
  // this is for alternating table row colors
  let rateCount = 0;
  return (<div className={classes['main']}>
    <div className="without-retail-rate" style={{ display: 'block' }}>
      <div style={{ width: withEditableCell ? '35%' : '51%', textAlign: 'left', display: 'inline-block', fontSize: '14px' }}>
        {`${(rateSetName || '').toUpperCase()}${rateSetCode ? ` (${rateSetCode})` : ''}`}
      </div>
      <div style={{ width: '14%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}>{'MINIMUM\nGUESTS'}</div>
      <div style={{ width: '18%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}>{'MAXIMUM\nGUESTS'}</div>
      <div style={{ width: '15%', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}>{'NETT\nRATE'}</div>
      { withEditableCell ? <div style={{ width: '16%', textAlign: 'right', paddingRight: '4px', whiteSpace: 'pre', display: 'inline-block' }}>{'APPLICABLE'}</div> : undefined }
    </div>
    <Divider style={{ marginTop: '8px', display: 'block' }} />
    <MouseOverEditDiv
      regularDiv={withEditableCell || forOffer}
      editable={supplierEditable}
      doubleLineTitle
      actionButtons={
        <EditButton
          onEdit={onEdit}
          onDelete={deleteFromProduct}
          deleteButton
        />
      }
    >
      <Miscellaneous {...forMiscellaneous} rateType="nett" classes={classes} />
      {
        // 'rates' MUST NOT be filtered because of the classes
        rates.map((rate, key) => {
          if (!withEditableCell && rate.notApplicable) return <span key={key}/>;
          const backgroundColor = rateCount % 2 !== 0 ? 'transparent' : 'rgba(0, 0, 0, 0.1)';
          rateCount++;
          return (
            <div style={{ backgroundColor }} key={key} className={classes[`${key}-rate`] || classes[`${key}-notApplicable`]}>
              <div className="rates-table-titles">
                <div
                  className={classes[`${key}-description`]}
                  style={{ width: withEditableCell ? '37%' : '51%', textAlign: 'left', paddingLeft: '4px', whiteSpace: 'pre', display: 'inline-block' }}
                >
                  {rate.description || 'Per Person'}
                </div>
                <Cell
                  className={classes[`${key}-minGuests`]}
                  inputAlignRight
                  decimalNumber={0}
                  defaultValue="-"
                  onChange={value => updateTableCell({ value, row: key, column: 'minGuests' })}
                  onBlur={() => {
                    if (Number(rate.minGuests) <= Number(rates[key - 1].minGuests)) {
                      alert('Current minimum guests have to be more than the last minimum guests.');
                      const maxMinMax = Math.max(Number(rates[key - 1].maxAdultsPlusChild), Number(rates[key - 1].minGuests));
                      updateTableCell({ row: key, column: 'minGuests', value: maxMinMax + 1 });
                    }
                  }}
                  style={{ width: '14%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}
                  editable={withEditableCell}
                >
                  {rate.minGuests}
                </Cell>
                <Cell
                  className={classes[`${key}-maxAdultsPlusChild`]}
                  inputAlignRight
                  decimalNumber={0}
                  defaultValue="-"
                  onBlur={() => {
                    if (Number(rate.maxAdultsPlusChild) < Number(rate.minGuests)) {
                      alert('Maximum guests have to be more than minimum guests.');
                      updateTableCell({ column: 'maxAdultsPlusChild', row: key, value: Number(rate.minGuests) + 1 });
                    }
                  }}
                  onChange={value => updateTableCell({ value, row: key, column: 'maxAdultsPlusChild' })}
                  style={{ width: '16%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', whiteSpace: 'pre', display: 'inline-block' }}
                  editable={withEditableCell}
                >
                  {rate.maxAdultsPlusChild}
                </Cell>
                <Cell
                  className={classes[`${key}-nettRate`]}
                  inputAlignRight
                  decimalNumber={2}
                  defaultValue="-"
                  onChange={value => updateTableCell({ value, row: key, column: 'nettRate' })}
                  style={{ width: withEditableCell ? '15%' : '18%', color: rate.notApplicable ? 'rgba(0, 0, 0, 0.34)' : '', textAlign: 'right', display: 'inline-block' }}
                  editable={withEditableCell}
                >
                  {rate.nettRate}
                </Cell>
                {
                  withEditableCell ?
                  <Checkbox style={{ width: '14%', top: '-2px', paddingLeft: '10%' }}
                    checked={!rate.notApplicable}
                    onCheck={() => updateTableCell({ value: !rate.notApplicable, row: key, column: 'notApplicable' })}
                  /> : undefined
                }
              </div>
            </div>
          );
        })
      }
    </MouseOverEditDiv>
    <Divider />
  </div>);
};

WithoutRetailRate.propTypes = {
  _id: PropTypes.string,
  supplierEditable: PropTypes.bool,
  rates: PropTypes.array,
  rateSetName: PropTypes.string,
  minStay: PropTypes.any,
  maxStay: PropTypes.any,
  withEditableCell: PropTypes.bool,
  updateTableCell: PropTypes.func,
  onEdit: PropTypes.func,
  daysOfWeek: PropTypes.array,
  deleteRates: PropTypes.func,
  deleteFromProduct: PropTypes.func,
  contractState: PropTypes.string,
};

export default WithoutRetailRate;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-tables/non-accom-rates-table/price-break-without-retail-rate.jsx